import styled from 'styled-components';

import { FormContent } from '@dreryk/react-components';

const StyledAnalyticalExaminationFormContent = styled(FormContent)`
   display: grid;
   gap: 30px;
   grid-template-columns: 2fr minmax(456px, 1fr);
`;

StyledAnalyticalExaminationFormContent.displayName = 'StyledAnalyticalExaminationFormContent';

export { StyledAnalyticalExaminationFormContent };
